export const arraySerializer = (arr: any[]) => arr.length
  ? arr.reduce((acc, cur) => `${acc}${cur}~`, '~') : ''
